import { ASSET_LIST } from './contracts';
import { parseUnits } from 'ethers/lib/utils'

export const RATCHET_PRICE_IN_USDC = parseUnits('36', ASSET_LIST.USDC.decimals).toNumber()